import { isUndefined } from 'lodash';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { ReportElementDesignOption } from '@/modules/ta/reportstudio/reportstudio.constants';

export class BaseOption extends BaseModel {
  /**
   * @type {boolean}
   */
  mirror_x;

  /**
   * @type {boolean}
   */
  mirror_y;

  /**
   * @type {number}
   */
  opacity;

  /**
   *
   * @type {string}
   */
  background_color;

  /**
   * @type {number}
   */
  border_radius;

  /**
   *
   * @type {string}
   */
  shadow_color;

  /**
   * @type {number}
   */
  shadow_blur;

  /**
   * @type {number}
   */
  shadow_x;

  /**
   * @type {number}
   */
  shadow_y;

  /**
   * @type {string}
   */
  border_color;

  /**
   * @type {number}
   */
  border_width;

  /**
   * @type {string}
   */
  border_type;

  /**
   * @type {number}
   */
  border_opacity;

  /**
   * @type {number}
   */
  rotate;

  constructor(model = {}) {
    super();

    this.mirror_x = model.mirror_x ?? false;
    this.mirror_y = model.mirror_y ?? false;
    this.opacity = model.opacity ?? 100;
    this.background_color = model.background_color;
    this.border_radius = model.border_radius ?? 5;
    this.shadow_color = model.shadow_color;
    this.shadow_blur = parseInt(model.shadow_blur, 10) || 10;
    this.shadow_x = parseInt(model.shadow_x, 10) ?? 0;
    this.shadow_y = parseInt(model.shadow_y, 10) ?? 0;
    this.border_color = model.border_color;
    this.border_width = model.border_width ?? 2;
    this.border_type = model.border_type ?? ReportElementDesignOption.BORDER_TYPE.SOLID;
    this.border_opacity = model.border_opacity ?? 100;
    this.rotate = model.rotate ?? 0;
  }

  checkBorderOptions() {
    return this.border_color && this.border_width && this.border_type && this.border_opacity;
  }

  checkShadowOptions() {
    return (
      !isUndefined(this.shadow_x) &&
      !isUndefined(this.shadow_y) &&
      !isUndefined(this.shadow_blur) &&
      this.shadow_color
    );
  }
}
